import React, { Component } from 'react';

export class RequestedHours extends Component{
    constructor(props){
        super(props) 
        
        if(props.requestStartDate !== null && props.requestEndDate !== null)
        {
            var difference = props.requestEndDate.diff(props.requestStartDate, 'days') +1            
            this.state ={
                businessDays: difference,
                rqHours: difference*8,
                beforePtotBalance: props.beforePtotBalance,
                beforeSickBalance: props.beforeSickBalance
            }
        }
        else{
            this.state = {
                rqHours: 8,
                businessDays: 0,
                beforePtotBalance:0            
            }
        }
    }

    componentWillReceiveProps(nextProps)
    {
        if(nextProps.isDateRangePickerClosed 
            && nextProps.requestEndDate !== null
            && nextProps.requestStartDate !== null){            
            var difference = nextProps.requestEndDate.diff(nextProps.requestStartDate, 'days') +1            
            this.setState({
                businessDays: difference,
                rqHours: difference*8,
                beforePtotBalance: nextProps.beforePtotBalance,
                beforeSickBalance: nextProps.beforeSickBalance
            })
        }

    }
    render(){
        let {
            rqHours,
            businessDays,
            beforePtotBalance,
            beforeSickBalance                        
        } = this.state;
        var balance = this.props.timeOffType === 1 || this.props.timeOffType === 0
        ? beforePtotBalance 
        : beforeSickBalance 

        let text = this.props.timeOffType === 1 ? "PTO" : this.props.timeOffType === 0 ? "Sick" : ""
        
        let aftertBalance = balance - rqHours
        return(
            <div>
                <label className="label_text left">Hours</label>
                <span 
                    className="input_items">
                    {
                        (this.props.timeOffType === 1 || this.props.timeOffType === 0) && this.props.isDateRangePickerClosed ?
                            <div className="input_hours">
                                <span className="rq_label">Requested Hours</span>
                                <span className="rq_value">{rqHours} Hrs ({businessDays} business days)</span>
                                <span className="rq_label">{text} Balance as of {this.props.requestStartDate.format('M/D/YYYY')}</span>
                                <span className="rq_value">{balance} Hrs (before request)</span>
                                <span className="rq_label">{text} Balance as of {this.props.requestEndDate.format('M/D/YYYY')}</span>
                                <span className="rq_value">{aftertBalance} Hrs (after request)</span>
                            </div>
                        : this.props.timeOffType !== '' && this.props.isDateRangePickerClosed ?
                            <div className="input_hours">                                
                                <span className="rq_value">{rqHours} Hrs ({businessDays} business days)</span>                                
                            </div>
                            :
                                <div className="input_hours">
                                -Hrs
                                </div>

                    }
                </span>
            </div>
        )
    }
} 




// WEBPACK FOOTER //
// ./src/features/timeoff/Modals/RequestedHours.js